import { G } from '@mobily/ts-belt';
import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useGetManyReference, useRecordContext } from 'react-admin';
import { useLocation } from 'react-router-dom';

import { B2bContract } from '@Common/types/bo/b2b/contracts';
import { B2bCompanyPlan } from '@Common/types/bo/b2b/plans';

import { B2bPlansProps } from '@sh4res/bo-common/components/B2bPlans/B2bPlansTypes';
import { B2bPlan } from '@sh4res/bo-common/components/B2bPlans/components/B2bPlan';
import { CeilingSection } from '@sh4res/bo-common/components/B2bPlans/components/CeilingSection';
import { EmptyScreen } from '@sh4res/bo-common/components/EmptyScreen';
import { EmptyPartySvg } from '@sh4res/bo-common/graphics';
import { navigateByQueryParam } from '@sh4res/bo-common/utils/navigate_by_query_param';

const B2bPlansRaw = ({ resource, emptyButton, editButton }: B2bPlansProps) => {
  const location = useLocation();
  const record = useRecordContext<B2bContract>();
  const { data: plans } = useGetManyReference<B2bCompanyPlan>(
    resource,
    {
      target: 'b2b_contract_id',
      id: record?.id ?? 0,
      sort: { field: 'created_at', order: 'DESC' },
    },
    { enabled: !!record },
  );

  useEffect(() => {
    if (!G.isNullable(plans) && plans.length > 0) {
      navigateByQueryParam(location, 'product_id', (productId) => `product-${productId}`);
    }
  }, [plans, location]);

  if (record === undefined || G.isNullable(plans)) {
    return;
  }

  if (plans.length === 0) {
    return (
      <EmptyScreen
        label="resources.bo_common.b2b.companies.saving_plans.empty"
        svg={<EmptyPartySvg />}
        button={emptyButton}
      />
    );
  }
  return (
    <>
      {plans.map((plan) => (
        <B2bPlan key={plan.id} plan={plan} resource={resource} editButton={editButton} />
      ))}
    </>
  );
};

export const B2bPlans = (props: B2bPlansProps) => (
  <Box>
    <CeilingSection />
    <B2bPlansRaw {...props} />
  </Box>
);
